import React, { useCallback, useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Avatar,
  Card,
  CardContent,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Button,
  Icon,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DonutChart from "../components/donutchart";
import { useDropzone } from "react-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Link, Outlet, useNavigate, useOutletContext } from "react-router-dom";
import { Storage } from "aws-amplify";
import {
  ChangeDetails,
  ChangePasswordM,
  getFile,
  GetUserData,
  uploadImg,
} from "../functions/authenticate";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DropFile from "../components/dropFile";
import { View } from "@aws-amplify/ui-react";
import { toast } from "react-toastify";
import ChangePassword from "./changePassword";
import SpinnerLoader from "../components/smallSpinner";
export default function Profile() {
  const [title, setTitle, subTitle, setSubTitle, getDat, dat] =
    useOutletContext();
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [editPass, setEditPass] = useState(false);
  const [editImg, setEditImg] = useState(false);
  const [editDetail, setEditDetail] = useState(false);
  const [password, setPassword] = useState(null);
  const [rpassword, setRPassword] = useState(null);
  const [opassword, setOPassword] = useState(null);
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [load, setLoad] = useState(false);
  const [dload, setDLoad] = useState(false);
  const [imgload, setImgLoad] = useState(false);
  const [profile, setProfile] = useState(null);
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach(async (file) => {
      setImgLoad(true);
      console.log(file);
      await uploadImg(file);
      setImgLoad(false);
      setEditImg(false);
      getData();
    });
  }, []);

  useEffect(() => {
    setTitle("Route");
    setSubTitle("Profile");
    console.log("title", title);
  }, []);

  const onChangeTxt = async (event, func) => {
    let value = event.target.value;
    func(value);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    let User = await GetUserData(navigate);
    if (User) {
      User = JSON.parse(User);
      setUserData(User);
      setName(User.name);
      setEmail(User.email);
      if (User.profile) {
        let imgL = await getFile(User.profile);
        if (imgL) {
          setProfile(imgL);
        }
      }
      getDat(!dat);
    }
  };

  const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.png']
    }
  });

  const submitPass = async () => {
    if (password && password == rpassword) {
      setLoad(true);
      let confPass = await ChangePasswordM(opassword, password, setEditPass);
      setLoad(false);
    } else {
      toast.error("Password must be valid and equal to confirm password");
    }
  };

  const submitDet = async () => {
    if (name && email) {
      setDLoad(true);
      let detail = await ChangeDetails(name, email, setEditDetail);
      setDLoad(false);
      getData();
    } else {
      toast.error("Please fillin all fields");
    }
  };

  return (
    <>
      <Grid container spacing={2} className="maindivpage">
        <Grid md={12} sm={12} xs={12} lg={12}>
          <h2 className="pagehead">Profile details</h2>
        </Grid>
        <Grid container className="profMainDiv">
          <Grid md={2} sm={12} xs={12} className="profSubDiv">
            <h3 style={{ width: "100%" }}>Profile Picture</h3>
            {!editImg ? (
              <div className="profAvatarDiv" align="center">
                {profile ? (
                  <View className="profImgM">
                    <img src={profile} className="profImg" />
                  </View>
                ) : (
                  <Avatar className="profAvatar">
                    {userData && userData.name.split("")[0]}
                  </Avatar>
                )}
                <Button
                  className="profBtn"
                  onClick={() => {
                    setEditImg(true);
                  }}
                >
                  <BorderColorIcon className="profIcn" /> &nbsp; Edit
                </Button>
              </div>
            ) : (
              <>
                {!imgload ? (
                  <div align="center">
                    <div className="dropContainerProf">
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input {...getInputProps()} />
                        <p>Drag & drop here</p>
                        <p>or</p>
                        <button
                          type="button"
                          className="dragbtn"
                        >
                          Browse
                        </button>
                      </div>
                    </div>
                    <Button
                      className="profBtn"
                      onClick={() => {
                        setEditImg(false);
                      }}
                    >
                      <BorderColorIcon className="profIcn" /> &nbsp; Cancel
                    </Button>
                  </div>
                ) : (
                  <SpinnerLoader visible={imgload} />
                )}
              </>
            )}
          </Grid>
          <Grid md={0.1} sm={0} xs={0}>
            <Divider orientation="vertical" />
          </Grid>
          <Grid md={9} sm={12} xs={12} className="profSubDiv">
            <Grid container>
              <Grid md={6} sm={6} xs={6}>
                <h3>About</h3>
              </Grid>
              <Grid md={6} sm={6} xs={6} align="right" paddingTop={3}>
                <a
                  className="profNormh"
                  onClick={() => {
                    setEditDetail(!editDetail);
                  }}
                >
                  <BorderColorIcon />
                </a>
              </Grid>
            </Grid>
            {!editDetail ? (
              <Grid container padding={2} paddingTop={1}>
                <Grid md={3} sm={6} xs={6}>
                  <p className="profHead">Name</p>
                </Grid>
                <Grid md={8} sm={6} xs={6}>
                  <p className="profNorm">{userData && userData.name}</p>
                </Grid>
                <Grid md={3} sm={6} xs={6}>
                  <p className="profHead">Email</p>
                </Grid>
                <Grid md={8} sm={6} xs={6}>
                  <p className="profNorm">{userData && userData.email}</p>
                </Grid>
                {/* Disabled Phone Number */}
                {/* <Grid md={3} sm={6} xs={6}>
                  <p className="profHead">Phone Number</p>
                </Grid>
                <Grid md={8} sm={6} xs={6}>
                  <p className="profNorm">-</p>
                </Grid> */}
              </Grid>
            ) : dload ? (
              <SpinnerLoader visible={dload} />
            ) : (
              <>
                <Grid container padding={2} paddingTop={1}>
                  <Grid md={3} sm={6} xs={6}>
                    <p className="profHead">Name</p>
                  </Grid>
                  <Grid md={4} sm={6} xs={6} container>
                    <Grid md={12} sm={12} xs={12}>
                      <TextField
                        fullWidth
                        label="Name"
                        autoComplete={false}
                        placeholder="Name"
                        value={name}
                        onChange={(e) => {
                          onChangeTxt(e, setName);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container padding={2} paddingTop={1}>
                  <Grid md={3} sm={6} xs={6}>
                    <p className="profHead">Email</p>
                  </Grid>
                  <Grid md={4} sm={6} xs={6} container>
                    {/* <Grid md={12} sm={12} xs={12}>
                      <TextField
                        fullWidth
                        label="Email"
                        autoComplete={false}
                        placeholder="Email"
                        value={email}
                        onChange={(e) => {
                          onChangeTxt(e, setEmail);
                        }}
                      />
                    </Grid> */}
                    <Grid md={12} sm={12} xs={12}>
                      <p className="profNorm">{userData && userData.email}</p>
                    </Grid>
                    <Grid style={{ marginTop: 20 }}>
                      <Button
                        onClick={() => {
                          setEditDetail(false);
                        }}
                        className="caseCancelBtn"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          submitDet();
                        }}
                        className="caseCreateBtn"
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
            <Divider />
            <h3>Password</h3>
            {!editPass ? (
              <Grid container padding={2} paddingTop={1}>
                <Grid md={3} sm={6} xs={6}>
                  <p className="profHead">Current Password</p>
                </Grid>
                <Grid md={4} sm={6} xs={6} container>
                  <Grid md={6} sm={12} xs={12}>
                    <p className="profNorm">***********</p>
                  </Grid>
                  <Grid md={6} sm={12} xs={12}>
                    <p
                      className="profNormh"
                      onClick={() => {
                        setEditPass(true);
                      }}
                    >
                      Change
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <>
                {load ? (
                  <SpinnerLoader visible={load} />
                ) : (
                  <>
                    <Grid container padding={2} paddingTop={1}>
                      <Grid md={3} sm={6} xs={6}>
                        <p className="profHead">Current Password</p>
                      </Grid>
                      <Grid md={4} sm={6} xs={6} container>
                        <Grid md={12} sm={12} xs={12}>
                          <TextField
                            fullWidth
                            label="Current Password"
                            autoComplete={false}
                            placeholder="*************"
                            value={opassword}
                            onChange={(e) => {
                              onChangeTxt(e, setOPassword);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container padding={2} paddingTop={1}>
                      <Grid md={3} sm={6} xs={6}>
                        <p className="profHead">New Password</p>
                      </Grid>
                      <Grid md={4} sm={6} xs={6} container>
                        <Grid md={12} sm={12} xs={12}>
                          <TextField
                            fullWidth
                            label="New Password"
                            autoComplete={false}
                            placeholder="*************"
                            value={password}
                            onChange={(e) => {
                              onChangeTxt(e, setPassword);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container padding={2} paddingTop={1}>
                      <Grid md={3} sm={6} xs={6}>
                        <p className="profHead">Confirm Password</p>
                      </Grid>
                      <Grid md={4} sm={6} xs={6} container>
                        <Grid md={12} sm={12} xs={12}>
                          <TextField
                            fullWidth
                            label="Confirm Password"
                            autoComplete={false}
                            placeholder="*************"
                            value={rpassword}
                            onChange={(e) => {
                              onChangeTxt(e, setRPassword);
                            }}
                          />
                        </Grid>
                        <Grid style={{ marginTop: 20 }}>
                          <Button
                            onClick={() => {
                              setEditPass(false);
                            }}
                            className="caseCancelBtn"
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              submitPass();
                            }}
                            className="caseCreateBtn"
                          >
                            Save
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
